import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as assignTag from "./assignTag";
import * as removeTag from "./removeTag";
import * as retrieveProjectsElementsTags from "./retrieveProjectsElementsTags";
import * as retrieveProjectsTags from "./retrieveProjectsTags";
import * as retrieveResourcesTags from "./retrieveResourcesTags";
import * as retrieveProjectResourcesTags from "./retrieveProjectResourcesTags";

const initialState: State = {
  assignTag: assignTag.initialState,
  removeTag: removeTag.initialState,
  retrieveProjectsElementsTags: retrieveProjectsElementsTags.initialState,
  retrieveProjectsTags: retrieveProjectsTags.initialState,
  retrieveResourcesTags: retrieveResourcesTags.initialState,
  retrieveProjectResourcesTags: retrieveProjectResourcesTags.initialState,
};

const reduceState = combineStateReducer(initialState, {
  assignTag: assignTag.reduceState,
  removeTag: removeTag.reduceState,
  retrieveProjectsElementsTags: retrieveProjectsElementsTags.reduceState,
  retrieveProjectsTags: retrieveProjectsTags.reduceState,
  retrieveResourcesTags: retrieveResourcesTags.reduceState,
  retrieveProjectResourcesTags: retrieveProjectResourcesTags.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...assignTag.createSelector(() => getState().assignTag),
    ...removeTag.createSelector(() => getState().removeTag),
    ...retrieveProjectsElementsTags.createSelector(
      () => getState().retrieveProjectsElementsTags,
    ),
    ...retrieveProjectsTags.createSelector(
      () => getState().retrieveProjectsTags,
    ),
    ...retrieveResourcesTags.createSelector(
      () => getState().retrieveResourcesTags,
    ),
    ...retrieveProjectResourcesTags.createSelector(
      () => getState().retrieveProjectResourcesTags,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
